'use client';

import React, { forwardRef } from 'react';
import { LAYOUT_SECTION_NAME } from 'shop-ui/constants';
import clsx from 'clsx';
import { type BasicShopUIPropTypes } from 'shop-ui/types';
import './Grid.scss';

interface GridProps extends BasicShopUIPropTypes {
    sectionName: LAYOUT_SECTION_NAME;
}

export const InnerGrid = forwardRef<HTMLDivElement, GridProps>((props, ref) => {
    const { children, id, type, style, className, sectionName, isEditingMode } = props;

    const childrenList = React.Children.toArray(children);

    if (!id) {
        return null;
    }

    const isEmpty = childrenList.length === 0;

    return (
        <div
            ref={ref}
            style={{
                ...style,
            }}
            className={clsx(
                type,
                className,
                isEditingMode && isEmpty && 'grid-secondary-level-inner--empty',
                sectionName === LAYOUT_SECTION_NAME.HEADER &&
                    isEditingMode &&
                    'header-section-inner-editing-mode',
                sectionName === LAYOUT_SECTION_NAME.HEADER &&
                    !isEditingMode &&
                    'header-section-inner'
            )}
            data-shop-component-inner-grid
        >
            {childrenList}
        </div>
    );
});

InnerGrid.displayName = 'InnerGrid';
